
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.7071 5.29289L16.1213 6.70711L10.8284 12L16.1213 17.2929L14.7071 18.7071L8 12L14.7071 5.29289Z" fill="currentColor"></path></svg>';export default svg;
    